Jelly.Payments.Amount_Changed = function(Parameters) {
	console.log(Parameters["Namespace"]);
	// Get amount
	var Amount = parseFloat($(
		"#" + Parameters["Namespace"] + " " + ".Payment .Input input"
	).val());
	
	// Selectively highlight the payment button
	if (Amount) {
		$(
			'#' + Parameters["Namespace"] + " " + ".Button_Container a:last-child"
		).
			addClass("Highlight");
		$(
			"#" + Parameters["Namespace"] + " " + ".Payment .Input"
		).
			addClass("Highlight");
	}
	else { 
		$(
				'#' + Parameters["Namespace"] + " " + ".Button_Container a:last-child"
			).
				removeClass("Highlight");
		$(
			"#" + Parameters["Namespace"] + " " + ".Payment .Input"
		).
			removeClass("Highlight");
	}

	// If this is a Donation action, update the amount
	if (Parameters["Kind"] == "Donation") {

		// Update the next step button label with the amount
		$(
			"#" + Parameters["Namespace"] + " " + ".Button_Container a:last-child .Label .Amount"
		).html(Amount)	
	}
	
	// Focus on amount input if not already focused
	$(
			"#" + Parameters["Namespace"] + " .Payment .Input input"
	).
		focus();
	
	/*
	// Get namespace
	var Namespace = Parameters["Namespace"];

	// Get input val
	var Value = parseFloat(Jelly.jQuery("#" + Namespace + " " + ".Payment" + " "  + ".Input" + " " + "input").val());
	
	// Get rewards
	var Items = Jelly.jQuery("#" + Namespace + " " + ".Reward_List_Item_Link");
	
	// Remove highlight
	Items.parent().removeClass('Highlight');
	
	// Remove reward value 
	Jelly.jQuery("#" + Namespace + "_Reward_Input_Finder" + " " + "[name=\"Reward\"]").val(null);

	// If the value is not blank
	if (!isNaN(Value))
	{
		var Adjusted_Minimum = parseFloat(Jelly.jQuery("#" + Namespace + " " + ".Payment" + " "  + ".Input_Description" + " " + ".Price").html());
		
		// Update payment button
		var Donation_Value = Value - Adjusted_Minimum;
		if (Donation_Value < 0) Donation_Value = 0;
		var Pay_Label = "Pay" + " " + "$" + Value;
		Pay_Label += "<span class=\"Operator\">(</span>" + "Donate"  + " " + "$" + Donation_Value  + "<span class=\"Operator\">)</span>";
		$('#' + Namespace + " " + ".Next_Step_Label").html(Pay_Label);
	
		// Create a list of elements organized by amount descending
		var Amount_Elements = [];	
		Items.each(function(Index) {
			var Amount = parseFloat(Jelly.jQuery(this).attr('data-amount'));
			Amount_Elements.push({
				'Amount': Amount,
				'Element': this
			});
		});
		Amount_Elements.sort(function(a,b) {return b.Amount - a.Amount;});

		// Get the first item by amount, and highlight that.
		var Highlight_Reward = false;
		Jelly.jQuery.each(Amount_Elements, function(Index, Amount_Element) {
			var Amount = Amount_Element['Amount'];
			if (Amount <= Value)
			{	
				// Report match for highlighting later.
				Highlight_Reward = true; 
			
				// Highlight the item
				var Amount_Element_Element = Amount_Element['Element'];
				Jelly.jQuery(Amount_Element_Element).parent().addClass('Highlight');
								
				// Get the ID value 
				var Amount_Item_ID = Jelly.jQuery(Amount_Element_Element).parent().attr('data-id');
				
				// Set the form value to the ID value 
				Jelly.jQuery("#" + Namespace + "_Reward_Input_Finder" + " " + "[name=\"Reward\"]").val(Amount_Item_ID);
							
				// Stop searching
				return false;
			}
		});
		
		// Highlight or unhighlight reward badge
		if (Highlight_Reward)
			$("#" + Namespace + " " + ".Payment" + " "  + ".Input" + " " + ".Gift").addClass("Highlight");
		else
			$("#" + Namespace + " " + ".Payment" + " "  + ".Input" + " " + ".Gift").removeClass("Highlight");
	}
	*/
};